webpackJsonp([1],{

/***/ 170:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  max-width: 300px;\n  margin: 0 1rem;\n  @media (min-width: 768px) {\n    margin-right: auto;\n    margin-left: auto;\n  }\n  margin-bottom: 3rem;\n  padding: 2rem;\n  border: 4px solid rgba(6, 190, 225, 1);\n'], ['\n  max-width: 300px;\n  margin: 0 1rem;\n  @media (min-width: 768px) {\n    margin-right: auto;\n    margin-left: auto;\n  }\n  margin-bottom: 3rem;\n  padding: 2rem;\n  border: 4px solid rgba(6, 190, 225, 1);\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  font-size: 2rem;\n  margin-bottom: 1rem;\n'], ['\n  font-size: 2rem;\n  margin-bottom: 1rem;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  font-family: \'Raleway\';\n  margin-bottom: 1rem;\n  line-height: 1.2;\n'], ['\n  font-family: \'Raleway\';\n  margin-bottom: 1rem;\n  line-height: 1.2;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  position: absolute;\n  bottom: -40px;\n  left: 50%;\n  transform: translate(-50%);\n'], ['\n  position: absolute;\n  bottom: -40px;\n  left: 50%;\n  transform: translate(-50%);\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  margin-bottom: 1rem;\n  padding: 0.875rem 1rem;\n  font-size: 1.25rem;\n  color: white;\n  background: #ff6b98;\n  border: none;\n  transition: all 250ms ease-in-out;\n  &:hover {\n    background: rgba(23, 104, 172, 1);\n  }\n'], ['\n  margin-bottom: 1rem;\n  padding: 0.875rem 1rem;\n  font-size: 1.25rem;\n  color: white;\n  background: #ff6b98;\n  border: none;\n  transition: all 250ms ease-in-out;\n  &:hover {\n    background: rgba(23, 104, 172, 1);\n  }\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  color: #ff6b98;\n  display: inline-block;\n  padding: 0 15px;\n  @media (min-width: 768px) {\n    padding: 0 25px;\n  }\n  user-select: all;\n'], ['\n  color: #ff6b98;\n  display: inline-block;\n  padding: 0 15px;\n  @media (min-width: 768px) {\n    padding: 0 25px;\n  }\n  user-select: all;\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  text-align: center;\n  position: relative;\n'], ['\n  text-align: center;\n  position: relative;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__(16);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Container = _styledComponents2.default.div(_templateObject);
var Heading = _styledComponents2.default.h2(_templateObject2);
var Copy = _styledComponents2.default.p(_templateObject3);
var Copied = (0, _styledComponents2.default)(Copy)(_templateObject4);
var Button = _styledComponents2.default.button(_templateObject5);
var Email = _styledComponents2.default.p(_templateObject6);
var AlignCenter = _styledComponents2.default.div(_templateObject7);

function createEmoji() {
  var emojis = ['🥳', '😚', '😃', '😎', '🙌', '👍', '👋', '🕺', '🔥', '✨', '💫', '🍾', '🎉', '👏', '💯'];
  var emoji = emojis[Math.floor(Math.random() * emojis.length)];
  return emoji;
}

var Clip = function (_Component) {
  _inherits(Clip, _Component);

  function Clip(props) {
    _classCallCheck(this, Clip);

    var _this = _possibleConstructorReturn(this, (Clip.__proto__ || Object.getPrototypeOf(Clip)).call(this, props));

    _this.clear = function () {
      setTimeout(function () {
        _this.setState({ copy: '' });
      }, 1800);
    };

    _this.copy = function () {
      // navigator.clipboard.writeText(this.props.text)

      var tempInput = document.createElement('input');

      tempInput.style = 'position: absolute; left: -1000px; top: -1000px';
      tempInput.value = _this.props.text;
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand('copy');
      document.body.removeChild(tempInput);

      _this.setState({ copy: 'Copied ' + createEmoji() + ' !' });
      _this.clear();
    };

    _this.state = {
      copy: ''
    };
    return _this;
  }

  _createClass(Clip, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        Container,
        null,
        _react2.default.createElement(
          AlignCenter,
          null,
          _react2.default.createElement(
            Heading,
            null,
            'Get in touch'
          ),
          _react2.default.createElement(
            Email,
            null,
            'matt@mattcdowning.com'
          )
        )
      );
    }
  }]);

  return Clip;
}(_react.Component);

exports.default = Clip;

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  padding-bottom: 80px;\n  width: 100%;\n  position: relative;\n  &:before {\n    content: \'\u201C\';\n    position: absolute;\n    font-size: 30px;\n    font-weight: bold;\n    top: 0;\n    left: -15px;\n    @media (min-width: 768px) {\n      font-size: 50px;\n      left: -30px;\n      top: -10px;\n    }\n  }\n'], ['\n  padding-bottom: 80px;\n  width: 100%;\n  position: relative;\n  &:before {\n    content: \'\u201C\';\n    position: absolute;\n    font-size: 30px;\n    font-weight: bold;\n    top: 0;\n    left: -15px;\n    @media (min-width: 768px) {\n      font-size: 50px;\n      left: -30px;\n      top: -10px;\n    }\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  line-height: 1.3;\n  font-size: 28px;\n  @media (min-width: 768px) {\n    font-size: 36px;\n  }\n  padding-bottom: 10px;\n  position: relative;\n  &:before {\n    content: \'\';\n    width: 80px;\n    height: 2px;\n    background: ', ';\n    position: absolute;\n    left: 50%;\n    transform: translateX(-50%);\n    top: -20px;\n  }\n'], ['\n  line-height: 1.3;\n  font-size: 28px;\n  @media (min-width: 768px) {\n    font-size: 36px;\n  }\n  padding-bottom: 10px;\n  position: relative;\n  &:before {\n    content: \'\';\n    width: 80px;\n    height: 2px;\n    background: ', ';\n    position: absolute;\n    left: 50%;\n    transform: translateX(-50%);\n    top: -20px;\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  color: ', ';\n  font-weight: 400;\n  font-size: 24px;\n  float: right;\n  font-family: \'Raleway\';\n  border-bottom: 4px solid transparent;\n  transition: all 350ms ease;\n  &:hover {\n    border-bottom: 4px solid ', ';\n  }\n'], ['\n  color: ', ';\n  font-weight: 400;\n  font-size: 24px;\n  float: right;\n  font-family: \'Raleway\';\n  border-bottom: 4px solid transparent;\n  transition: all 350ms ease;\n  &:hover {\n    border-bottom: 4px solid ', ';\n  }\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__(16);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var darkblue = 'rgba(23, 104, 172, 1)';
var lightblue = 'rgba(6, 190, 225, 1)';
var pink = '#FF6B98';

var StyledQuote = _styledComponents2.default.div(_templateObject);
var Text = _styledComponents2.default.blockquote(_templateObject2, darkblue);

var Name = _styledComponents2.default.a(_templateObject3, lightblue, pink);

var Quote = function Quote(_ref) {
  var text = _ref.text,
      name = _ref.name,
      link = _ref.link;
  return _react2.default.createElement(
    StyledQuote,
    null,
    _react2.default.createElement(
      Text,
      null,
      text,
      '\u201D'
    ),
    _react2.default.createElement(
      'cite',
      null,
      _react2.default.createElement(
        Name,
        { href: link },
        name
      )
    )
  );
};

exports.default = Quote;

/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n'], ['\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 0 15px;\n'], ['\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 0 15px;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  padding-left: 30px;\n  padding-right: 30px;\n  @media (min-width: 500px) {\n    padding-left: 50px;\n    padding-right: 0;\n  }\n'], ['\n  padding-left: 30px;\n  padding-right: 30px;\n  @media (min-width: 500px) {\n    padding-left: 50px;\n    padding-right: 0;\n  }\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  height: auto;\n  border-radius: 50%;\n  margin: 20px 15px;\n  max-width: calc(100% - 30px);\n  @media (min-width: 768px) {\n    max-width: 50%;\n    flex: 6;\n    height: auto;\n    margin: 0;\n  }\n  @media (min-width: 1200px) {\n    flex: 6;\n  }\n'], ['\n  height: auto;\n  border-radius: 50%;\n  margin: 20px 15px;\n  max-width: calc(100% - 30px);\n  @media (min-width: 768px) {\n    max-width: 50%;\n    flex: 6;\n    height: auto;\n    margin: 0;\n  }\n  @media (min-width: 1200px) {\n    flex: 6;\n  }\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  @media (min-width: 768px) {\n    flex: 6;\n  }\n  @media (min-width: 1200px) {\n    flex: 6;\n  }\n'], ['\n  @media (min-width: 768px) {\n    flex: 6;\n  }\n  @media (min-width: 1200px) {\n    flex: 6;\n  }\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  background: ', ';\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  max-width: 880px;\n  margin: 30px 15px 150px 15px;\n  @media (min-width: 768px) {\n    padding: 40px;\n    margin: 120px 15px 240px 15px;\n  }\n  border: 2px solid ', ';\n'], ['\n  background: ', ';\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  max-width: 880px;\n  margin: 30px 15px 150px 15px;\n  @media (min-width: 768px) {\n    padding: 40px;\n    margin: 120px 15px 240px 15px;\n  }\n  border: 2px solid ', ';\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  background: ', ';\n  font-size: 28px;\n  margin: 0 15px;\n  @media (min-width: 768px) {\n    margin-left: -100px;\n    font-size: 40px;\n  }\n  @media (min-width: 992px) {\n    font-size: 60px;\n  }\n  margin-bottom: 20px;\n  padding: 10px 20px;\n  text-transform: uppercase;\n  font-weight: 100;\n'], ['\n  background: ', ';\n  font-size: 28px;\n  margin: 0 15px;\n  @media (min-width: 768px) {\n    margin-left: -100px;\n    font-size: 40px;\n  }\n  @media (min-width: 992px) {\n    font-size: 60px;\n  }\n  margin-bottom: 20px;\n  padding: 10px 20px;\n  text-transform: uppercase;\n  font-weight: 100;\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n  font-family: \'Raleway\';\n  margin: 0 15px;\n  margin-bottom: 20px;\n  padding: 13px 20px 10px 20px;\n  background: ', ';\n  font-size: 18px;\n  @media (min-width: 768px) {\n    margin-left: -75px;\n    font-size: 28px;\n  }\n  text-transform: uppercase;\n'], ['\n  font-family: \'Raleway\';\n  margin: 0 15px;\n  margin-bottom: 20px;\n  padding: 13px 20px 10px 20px;\n  background: ', ';\n  font-size: 18px;\n  @media (min-width: 768px) {\n    margin-left: -75px;\n    font-size: 28px;\n  }\n  text-transform: uppercase;\n']),
    _templateObject9 = _taggedTemplateLiteral(['\n  font-family: \'Raleway\';\n  margin: 0 15px;\n  line-height: 1.5;\n  background: ', ';\n  color: ', ';\n  @media (min-width: 768px) {\n    margin-left: -50px;\n  }\n  margin-bottom: 15px;\n  padding: 15px 20px;\n'], ['\n  font-family: \'Raleway\';\n  margin: 0 15px;\n  line-height: 1.5;\n  background: ', ';\n  color: ', ';\n  @media (min-width: 768px) {\n    margin-left: -50px;\n  }\n  margin-bottom: 15px;\n  padding: 15px 20px;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(18);

var _styledComponents = __webpack_require__(16);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Quote = __webpack_require__(210);

var _Quote2 = _interopRequireDefault(_Quote);

var _Clip = __webpack_require__(170);

var _Clip2 = _interopRequireDefault(_Clip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var white = 'rgba(241, 250, 238, 1)';
var darkblue = 'rgba(23, 104, 172, 1)';
var green = 'rgba(168, 218, 220, 1)';
var pink = '#FF6B98';

var MastHead = _styledComponents2.default.header(_templateObject);
var Container = _styledComponents2.default.div(_templateObject2);
var QuoteContainer = Container.extend(_templateObject3);
var Avatar = _styledComponents2.default.img(_templateObject4);
var Bio = _styledComponents2.default.div(_templateObject5);
var BioContainer = _styledComponents2.default.div(_templateObject6, green, darkblue);
var Name = _styledComponents2.default.h1(_templateObject7, white);
var Title = _styledComponents2.default.p(_templateObject8, pink);
var Copy = _styledComponents2.default.p(_templateObject9, darkblue, white);

var Home = function (_Component) {
  _inherits(Home, _Component);

  function Home() {
    _classCallCheck(this, Home);

    return _possibleConstructorReturn(this, (Home.__proto__ || Object.getPrototypeOf(Home)).apply(this, arguments));
  }

  _createClass(Home, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
          MastHead,
          null,
          _react2.default.createElement(
            BioContainer,
            null,
            _react2.default.createElement(Avatar, {
              alt: '',
              src: 'https://res.cloudinary.com/mattcdowning/image/upload/f_auto/Image_uir1b3.png'
            }),
            _react2.default.createElement(
              Bio,
              null,
              _react2.default.createElement(
                Name,
                null,
                'Matt Downing'
              ),
              _react2.default.createElement(
                Title,
                null,
                'Web Developer & Strategist'
              ),
              _react2.default.createElement(
                Copy,
                null,
                'Helping businesses thrive online.'
              )
            )
          )
        ),
        _react2.default.createElement(
          QuoteContainer,
          null,
          _react2.default.createElement(_Quote2.default, {
            text: 'Matt\'s kind, efficient, and a total pleasure to work with!',
            name: 'Jocelyn K. Glei',
            link: 'https://reset-course.com'
          }),
          _react2.default.createElement(_Quote2.default, {
            text: 'It is refreshing to get this type of quality web development.',
            name: 'Neil Schuster',
            link: 'https://nolayingup.com'
          }),
          _react2.default.createElement(_Quote2.default, {
            text: 'Matt provided spot on insight and delivered a website I could not be\n            happier with.',
            name: 'Bennett Zamoff',
            link: 'https://tampabayintl.netlify.app/'
          }),
          _react2.default.createElement(_Quote2.default, {
            text: 'I have recieved high praise for our website\u2019s look and feel, ease of\n        use, and color selection!',
            name: 'Lynn Villyard',
            link: 'https://odyssey-center.netlify.app/'
          }),
          _react2.default.createElement(_Quote2.default, {
            text: '\n        If you want your website designed and developed, I couldn\'t recommend anyone more highly.',
            name: 'Benjamin Hardy',
            link: 'https://www.benjaminhardy.com'
          })
        ),
        _react2.default.createElement(_Clip2.default, null)
      );
    }
  }]);

  return Home;
}(_react.Component);

exports.default = Home;

/***/ })

});


// WEBPACK FOOTER //
// templates/src/containers/Home.30d5af58.js